import moment from 'moment';

import { KaseApi } from '@/api';
import { DATE_FORMAT } from '@/config';
import { IAddress } from '@/models';

import { FormActionType } from './DomesticIncidentReport';

export const dateSectionExtract = (sectionData: {
  [x: string]: any;
  customAddress: string;
  customAddressStreet: string;
  customAddressCityStateZip: string;
  phone: any;
}) => {
  if (!sectionData) {
    return {};
  }
  const {
    customAddress,
    customAddressStreet,
    customAddressCityStateZip,
    phone,
    ...rest
  } = sectionData;
  return rest;
};

export const dateHelper = (date?: string) =>
  date ? moment(date).format(DATE_FORMAT) : '';

const addressHelper = (currentAddress: IAddress) => {
  const { zipName = '', zipcode = '', state = '' } = currentAddress || {};
  return {
    address: `${currentAddress?.addressLabel || ''} ${
      currentAddress?.subAddress || ''
    }`,
    city_state_zip: [zipName, zipcode, state].filter((item) => item).join(', '),
  };
};

const customAddressHelper = (
  customAddressStreet: string,
  AddressCityStateZip: string,
) => {
  return {
    address: customAddressStreet || '',
    city_state_zip: AddressCityStateZip || '',
  };
};

export const addressHandler = (
  sectionValues: {
    customAddress: boolean;
    customAddressStreet: string;
    customAddressCityStateZip: string;
    address: IAddress;
  },
  submitter: FormActionType,
) => {
  return sectionValues?.customAddress === true
    ? {
        ...(submitter === 'SAVE_AS_DRAFT' && { customAddress: true }),
        ...customAddressHelper(
          sectionValues?.customAddressStreet,
          sectionValues?.customAddressCityStateZip,
        ),
      }
    : submitter === 'SAVE_AS_DRAFT'
    ? { address: sectionValues.address }
    : addressHelper(sectionValues?.address);
};

export const handleResponse = async (
  ID: string,
  dataToPrint: any,
  action: FormActionType,
  includeHelpSheet = false,
) => {
  const response = await KaseApi.print(
    ID,
    {
      ...dataToPrint,
      action,
    },
    includeHelpSheet,
  );

  if (response.data) {
    const pdfUrl = URL.createObjectURL(
      new Blob([response.data], { type: 'application/pdf' }),
    );
    // prepare pdf blob and print file
    // open print pdf file in new window tab
    const newWindow = window.open('', '_blank');
    const iframe = document.createElement('iframe');
    iframe.src = pdfUrl;
    iframe.width = '100%';
    iframe.height = '100%';
    iframe.style.border = 'none';
    iframe.onload = function () {
      setTimeout(function () {
        iframe.focus();
        iframe?.contentWindow?.print();
      }, 1000);
    };
    newWindow?.document?.body.appendChild(iframe);
  }

  return response;
};

export const extractCustomAddress = (draftContent?: any) => {
  if (!draftContent) {
    return {};
  }
  const customAddressSections = [
    'incident',
    'victim',
    'suspect_p2',
    'witnesses_1',
    'witnesses_2',
    'witnesses_3',
  ];

  return customAddressSections.reduce((acc, item) => {
    if (draftContent[item]) {
      if (draftContent[item].customAddress) {
        return {
          ...acc,
          [item]: {
            ...draftContent[item],
            ...(draftContent[item].customAddress && {
              customAddressStreet: draftContent[item].address || '',
              customAddressCityStateZip:
                draftContent[item].city_state_zip || '',
            }),
          },
        };
      } else if (draftContent[item].address) {
        return {
          ...acc,
          [item]: {
            ...draftContent[item],
            ...(draftContent[item].address && {
              address: draftContent[item].address,
            }),
          },
        };
      }
    }
    return acc;
  }, {} as any);
};

export const populateSectionValues = (values: any) => {
  const sectionKeys = [
    'victim_interview',
    'suspect',
    'incident_p2',
    'evidence',
    'offense',
    'closing_notes',
  ];

  return sectionKeys.reduce((acc, item) => {
    return {
      ...acc,
      ...(values[item] && {
        [item]: {
          ...dateSectionExtract(values[item]),
        },
      }),
    };
  }, {} as any);
};
